import { COMPONENT_NAME as VALVE_MANAGE_COMPONENT_NAME, ValveManageComponent } from './action-run-dedicated/'
import { VALVE_MANAGE_SERVICE_NAME } from './action-run-dedicated/action-run-dedicated-valve-manage/services'
import { ValveManageService } from './action-run-dedicated/action-run-dedicated-valve-manage/services/valve-manage.service'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'

export const ACTION_RUN_MODULE_NAME = 'simax.common.action-run'

const module = angular.module(ACTION_RUN_MODULE_NAME, [])

module.component(VALVE_MANAGE_COMPONENT_NAME, new ValveManageComponent())

module.service(VALVE_MANAGE_SERVICE_NAME,
    [
        USER_SESSION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        (
            userSessionService: UserSessionService,
            gridService: GridService
        ) => new ValveManageService(userSessionService, gridService)
    ]
)